import { Table } from '@dreryk/react-components';

import { TABLE_PAGE_SIZE } from '../shared/constants';

import {
   useGynecologicalInterviewLazyLoadedDataConfiguration,
   useGynecologicalInterviewTableColumns,
} from './GynecologicalInterviewTable.hooks';

type MedicalInformationTableProps = {
   readonly patientId: number;
   readonly highlightedEntryId?: number;
};

export const GynecologicalInterviewTable = (props: MedicalInformationTableProps): JSX.Element => {
   const dataConfiguration = useGynecologicalInterviewLazyLoadedDataConfiguration(props.patientId);
   const columns = useGynecologicalInterviewTableColumns(dataConfiguration.refetch);

   return (
      <Table
         testId={'medicalInformation'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         pageSize={TABLE_PAGE_SIZE}
         highlightedRowKey={props.highlightedEntryId}
      />
   );
};
